<template>
  <div class="apb-Wrapper">
    <AppBannerExtended
      :type="APP_BANNER_EXTENDED_TYPES.VERTICAL"
      class="apb-Wrapper_Banner"
      @close="dismissAppMenuPromotionBanner"
    >
      <template #title>
        {{ t('checkins.banner.app_menu.title') }}
      </template>
      <template #description>
        {{ t('checkins.banner.app_menu.description') }}
      </template>
      <template #overline>
        <AppBadge :content="t('action.updated')" class="apb-Wrapper_Overline" inline />
      </template>
      <template #content>
        <AppIcon height="29" icon-name="checkins-banner" width="158" />
      </template>
      <template #actions>
        <AppButtonNext
          :size="BUTTON_SIZES_NEXT.SM"
          :variant="BUTTON_VARIANTS.SECONDARY"
          icon-after="arrow-right-next"
          @click="goToAlerts"
        >
          {{ t('checkins.banner.app_menu.button') }}
        </AppButtonNext>
      </template>
    </AppBannerExtended>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useSettingsBackButton } from '@/composables/settings-back-button'
import { ROUTE_NAMES } from '@/routes/route-helpers'
import { APP_BANNER_EXTENDED_TYPES } from '@/utils/components-configurations/app-banner-extended'
import { BUTTON_SIZES_NEXT, BUTTON_VARIANTS } from '@/utils/components-configurations/app-button'
import {
  APP_MENU_PROMOTION_BANNER_ID,
  DEFAULT_USERS_SETTINGS,
  USER_SETTINGS_MAPPER
} from '@/utils/user-settings'

import AppBannerExtended from '@/components/AppBannerExtended'
import AppBadge from '@/components/ui/AppBadge/AppBadge'
import AppButtonNext from '@/components/ui/AppButtonNext/AppButtonNext'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'AutomationsPromoBanner'
})

const { t } = useI18n()
const { saveSettingsReferer } = useSettingsBackButton()
const router = useRouter()
const store = useStore()

const goToAlerts = () => {
  saveSettingsReferer()
  router.push({ name: ROUTE_NAMES.SETTINGS_AUTOMATIONS })
}

const dismissAppMenuPromotionBanner = async () => {
  await store.dispatch('system/updateUserSettings', {
    [USER_SETTINGS_MAPPER[APP_MENU_PROMOTION_BANNER_ID]]:
      DEFAULT_USERS_SETTINGS[APP_MENU_PROMOTION_BANNER_ID]
  })
}
</script>

<style lang="scss" scoped>
$padding: 20px;

.apb-Wrapper {
}

.apb-Wrapper_Overline {
  --badge-size: 18px;
  --font-size: #{$fs-12};
  --padding: 0px 6px;
  --color: #{rgba($white, 0.1)};
  --badge-border-radius: #{$border-radius-sm};
}
</style>
